import React, { useRef } from 'react'
import { SnackbarProvider as Provider, SnackbarProviderProps, SnackbarKey } from 'notistack'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'

export default function SnackbarProvider(props: SnackbarProviderProps) {
  const { children, ...rest } = props
  const notistackRef = useRef<Provider | null>(null)

  const handleDismissSnackbar = (key?: SnackbarKey) => () => {
    notistackRef.current?.closeSnackbar(key)
  }

  return (
    <Provider
      ref={notistackRef}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right'
      }}
      action={(key) => (
        <IconButton
          size="small"
          aria-label="close"
          color="inherit"
          onClick={handleDismissSnackbar(key)}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      )}
      autoHideDuration={3000}
      {...rest}
    >
      {children}
    </Provider>
  )
}
